const getters = {
  websocket: (state) => state.webSocket.websocket,
  posData: (state) => state.webSocket.posData,
  multData: (state) => state.webSocket.multData,
  alarmMsgCount: (state) => state.webSocket.alarmMsgCount,
  unreadCount: (state) => state.webSocket.unreadCount,
  uploadData: (state) => state.webSocket.uploadData,
  monitorType: (state) => state.webSocket.monitorType,
  ioData: (state) => state.webSocket.ioData,

  searchLen: (state) => state.systemConfig.searchLen,
  isSubmitted: (state) => state.systemConfig.isSubmitted,
  loginName: (state) => state.systemConfig.loginName,
  asideCollapse: (state) => state.systemConfig.asideCollapse,

  userInfo: (state) => state.user.info,
  rolesList: (state) => state.user.rolesList,
  actionList: (state) => state.user.actionList,
  historySearchData: (state) => state.user.historySearchData,
  historySearchPage: (state) => state.user.historySearchPage,
  addRouters: (state) => state.permission.addRouters,
  routers: (state) => state.permission.routers,

  orderCause: (state) => state.systemDict.orderCause,
  carTypeArr: (state) => state.systemDict.carTypeArr,
}
// 遍历模块表格名称
export default getters
